import { render } from "./LessonPlan.vue?vue&type=template&id=db68aa06"
import script from "./LessonPlan.vue?vue&type=script&lang=js"
export * from "./LessonPlan.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__